export default __webpack_public_path__ + "static/media/Hermes.b24318e0.png";